import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import {dateTransformation} from '../../utils.js'
import { makeStyles } from "@mui/styles";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {logger,checkAuthentication} from '../../utils';

export default function EditExpenseDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const currencyRegEx = /^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/;

    const [poChoices, setPoChoices] = React.useState([])
    const [labChoices, setLabChoices] = React.useState([])
    const [invoices, setInvoicesDataSet] = React.useState([]);

    const initialValues = {
		ID: data.ID,
		Name: data.Name,
        Invoice: data.InvoiceID,
        Lab: data.LabID,
        Comment: data.Comment,
        Date: moment.utc(data.Date).format("MM/DD/YYYY"),        
        Amount: parseFloat(data.Amount).toFixed(2)
    };
	
	/*const useStyles = makeStyles((theme) => ({
	  root: {
	    '& .MuiInputBase-root': {
	     	backgroundColor: "#FFFFFF",
            padding: '5px 10px 5px',
            height: '100px',
            
	    },
	  },
	}));
	
	const classes = useStyles();*/
    const validFormSchema = Yup.object({
		Name: Yup
            .string('Enter a Name to this expense ')
            .required('Name is required'),
        Invoice: Yup
            .string('Enter a name for the expense')
            .required('Invoice is required'),
        Lab: Yup
            .string('Enter a Lab for the expense')
            .required('Lab is required'),
        Comment: Yup
            .string('Enter a name for the expense'),
        Date: Yup
            .date('Enter a date for this expense')
            .required('Date is required'),        
        Amount: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value.toFixed(2)+"").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
        ),
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
			ID: data.ID,
			Name: values.Name,
            Invoice: values.Invoice,
            Lab: values.Lab,
            Comment: values.Comment,
            Amount: parseFloat(values.Amount).toFixed(2),
            Date: moment.utc(values.Date)
        };

        handleEditCallback(msg);        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPoChoices(choices)
    }

    const getLabChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setLabChoices(choices)
    };
    
    const setInvoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.InvoiceNumber, value: choice.ID }))
        setInvoicesDataSet(choices)
    };

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            fetch('api/PO/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));

            fetch('api/Lab/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => getLabChoices(json))
            
            fetch('api/Invoice', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setInvoices(json))

            setRefresh(false);
            logger(initialValues);
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen} >
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit Expense
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Expense Info:</DialogTitle>
                                <div>
                                	<FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name='Name'
                                            id="outlined-ExpenseName"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="ExpenseName"
                                        />
                                    </FormControl>                                  
                                       <FormControl  sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Lab">Lab</InputLabel>
                                        <CustomSelect
                                            name='Lab'
                                            id="outlined-Lab"
                                            options={labChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Lab}
                                            error={props.touched.Lab && Boolean(props.errors.Lab)}
                                            helperText={props.touched.Lab && props.errors.Lab}
                                            label="Lab"
                                        />
                                    </FormControl>
                    
                                    
                                </div>
                                <div>
                                 	<FormControl  sx={{ m: 1, width: 220 }}>                                        
                                        <InputLabel htmlFor="outlined-Invoice">Invoice</InputLabel>                                      
                                        <CustomSelect
                                            name='Invoice'
                                            id="outlined-Invoice"
                                            options={invoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Invoice}
                                            error={props.touched.Invoice && Boolean(props.errors.Invoice)}
                                            helperText={props.touched.Invoice && props.errors.Invoice}                                
                                            label="Invoice"
                                        />
                                    </FormControl>                    
                                    <FormControl  sx={{ m: 1, width: 220 }}>                                        
                                       <TextField
                                            name='Amount'
                                            id="outlined-Amount"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Amount}
                                            error={props.touched.Amount && Boolean(props.errors.Amount)}
                                            helperText={props.touched.Amount && props.errors.Amount}
                                            label="Amount"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl  sx={{ m: 1 , width: 220}}>                                        
                                       
                                         <TextField
                                            name='Comment'
                                            id="outlined-Comment"
                                            multiline
                                            row={4}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Comment}
                                            label="Comment"
                                        />
                                     
                                    </FormControl>
                        
                                    <FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name='Date'
                                            id="outlined-Date"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            type= "date"
                                            value={props.values.Date.indexOf("/")>0?dateTransformation(props.values.Date):props.values.Date}
                                            error={props.touched.Date && Boolean(props.errors.Date)}
                                            helperText={props.touched.Date && props.errors.Date}
                                            label="Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                                     
            </Dialog></MuiThemeProvider>
        </div>
    );
}